import { FC, HTMLAttributes } from 'react';

const Close: FC<HTMLAttributes<SVGElement>> = (props) => {
	return (
		<svg
			fill="none"
			height="24"
			style={{ minWidth: 24 }}
			viewBox="0 0 24 24"
			width="24"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M5 5L19 19M5.00003 19L12 12L19 5"
				stroke="var(--tertiary-gray)"
				strokeLinecap="round"
				strokeWidth="2"
			/>
		</svg>
	);
};

export default Close;
